import { render, staticRenderFns } from "./ClTask.vue?vue&type=template&id=7197e94a&scoped=true&"
import script from "./ClTask.vue?vue&type=script&lang=ts&"
export * from "./ClTask.vue?vue&type=script&lang=ts&"
import style0 from "./ClTask.vue?vue&type=style&index=0&id=7197e94a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7197e94a",
  null
  
)

export default component.exports